import { botConfigs } from '@/BotConfigs/botConfigs';
import { EBotNames } from '@/BotConfigs/botNames';
import { IBotConfigType } from '@/types/botConfigTypes';
import { createContext, type PropsWithChildren } from 'react';

interface IBotConfigContextType {
  currentBotConfig: IBotConfigType | undefined;
}

const BotConfigContext = createContext<IBotConfigContextType | null>(null);

interface IBotConfigProps {
  botName?: EBotNames;
}

function BotConfigProvider({
  children,
  botName,
}: PropsWithChildren<IBotConfigProps>) {
  const bot = botName || EBotNames.TELEHEALTH_TRIAGE;
  const currentBotConfig = botConfigs[bot] ?? undefined;

  if (!currentBotConfig) throw `Config for ${bot} is not defined`;

  return (
    <BotConfigContext.Provider value={{ currentBotConfig }}>
      {children}
    </BotConfigContext.Provider>
  );
}

export { BotConfigContext };
export default BotConfigProvider;
